import { formatMessage } from 'model/message';

const MAX_HEALTH_GAIN = 10;
const CITY_REST_SUCCESS_CHANCE = 0.9;

const message = ({ success, gain }) =>
  success ? formatMessage('the body mends what it can', { gain }) : formatMessage('no rest in it');

const attempt = ({ calendar, party }) => {
  const result = {
    success: calendar.isNight() || Math.random() < CITY_REST_SUCCESS_CHANCE,
    cost: {},
    gain: {
      health: 0
    }
  };

  if (!result.success) return result;

  result.gain.health = Math.min(
    100 - party.resources.attribs.health.value,
    Math.floor(Math.random() * MAX_HEALTH_GAIN)
  );
  result.success = result.gain.health > 0;

  return result;
};

const executeSideEffects = (context, result) => {
  const { party, calendar } = context;
  const { gain } = result;
  const { history, resources } = party;

  // Track action
  history.add({ action: 'rest', day: calendar.step, result });

  // Update resources
  resources.delta({ health: gain.health }, context);

  // Time passes
  calendar.next(context);

  // notify of the results
  return {
    message: message(result)
  };
};

const action = {
  title: ({ calendar, party }) => `Rest (${party.history.remainingToday(calendar.step)})`,
  enabled: ({ party }) => party.resources.attribs.food.value > 0,
  execute: context => {
    const result = attempt(context);
    const { message, notification } = executeSideEffects(context, result);

    return { result: { message }, notification };
  }
};

export default action;
